import { Badge, Drawer } from "antd";
import { useEffect, useMemo, useState } from "react";
import styles from "./FiltersUnitMobile.module.scss";
import FiltersUnit from "../FiltersUnit";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import {
  DEFAULT_SEARCH_PARAMS,
  ParamsFilterKey,
} from "Config/filterSearchParams";
import { IconPack } from "Explore/Config/Icons";
import { AutoCompleteSearch } from "Explore/Components";
import { getSuggestSearchUnits } from "Explore/Services/Unit";

const FiltersUnitMobile = () => {
  const { filter, updateSearchParams } = useFilterAndPagination();
  const [open, setOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState(filter);

  const totalFilterApplied = useMemo(
    () =>
      Object.keys(filter).reduce((total, key) => {
        let _total = total;
        if (!!filter[key]) {
          if (Array.isArray(filter[key])) {
            _total += filter[key].length;
          } else if (filter[key] !== DEFAULT_SEARCH_PARAMS[key]) {
            _total += 1;
          }
        }
        return _total;
      }, 0),
    [filter]
  );

  useEffect(() => {
    setTempFilters(filter);
  }, [filter]);

  const onClose = () => {
    setOpen(false);
    setTempFilters(filter);
  };
  const showDrawer = () => {
    setOpen(true);
  };
  const onApplyFilters = () => {
    updateSearchParams(tempFilters);
    setOpen(false);
  };
  const onClearFilters = () => {
    setTempFilters(DEFAULT_SEARCH_PARAMS);
  };
  return (
    <div className={styles["filters-unit-mobile"]}>
      {/* <AutoCompleteSearch
        placeholder={"Search by unit"}
        functionSearch={getSuggestSearchUnits}
        filters={filter}
        setFilters={updateSearchParams}
        entity={filter[ParamsFilterKey.QUERY]}
        // style={
        //   isMobile
        //     ? { height: "36px" }
        //     : { borderRadius: "40px", height: "40px" }
        // }
      /> */}
      <Badge count={totalFilterApplied}>
        <div className={styles["filter-trigger"]} onClick={showDrawer}>
          {IconPack.menuIcon}
        </div>
      </Badge>

      <Drawer
        title="Unit filters"
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        open={open}
        height={"90%"}
        zIndex={1001}
        footer={
          <div className={styles["filters-footer"]}>
            <button
              className={styles["clear-button"]}
              onClick={() => onClearFilters()}
            >
              Clear
            </button>
            <button
              className={styles["apply-button"]}
              onClick={() => onApplyFilters()}
            >
              Apply
            </button>
          </div>
        }
      >
        <FiltersUnit filter={tempFilters} updateFilter={setTempFilters} />
      </Drawer>
    </div>
  );
};

export default FiltersUnitMobile;
